import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLockFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLockFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '539bee6782de6597e3dc14607d16a1dc5026e60f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3b1bc206e92fc07cf27c0bd7f87693a64b797fe8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a02960770633549a35ced5f9c06cde0e67517fc6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 8H15V6a4 4 0 0 0-8 0v2H4.53a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.53-.5m-5.75 5.8v1.69a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V13.8a1.5 1.5 0 1 1 1.5 0M13.5 8h-5V6a2.5 2.5 0 0 1 5 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-lock-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-lock-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-lock-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLockFilled$1);
            }
            break;
    } });
}

const CosmosIconLockFilled = CosmosIconLockFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLockFilled, defineCustomElement };
